import { Component, Input, OnInit } from "@angular/core";
import { AppConfig } from "src/app/services/AppConfig";
import {environment} from '../../../environments/environment';

@Component({
  selector: "app-titre",
  templateUrl: "./app-titre.component.html",
  styleUrls: ["./app-titre.component.css"],
})
export class AppTitreComponent implements OnInit {
  @Input("titre") titre;
  IS_ENV_TEST = !environment.production;

  constructor() {}

  ngOnInit() {}
}
